
import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { deleteDriver } from '../../firebase-services/db-services'
import { getDriversFetch, selectDrivers, setActiveDriver } from '../../Redux/slices/driverState'
import ConfirmDIalouge from '../ConfirmDIalouge'
import DriverCard from './DriverCard'
import {  toast } from 'react-toastify';
export default function ViewDrivers({setEditHandler}) {
    const dispatch = useDispatch()
    const drivers = useSelector(selectDrivers)
    const [selectDelete,setSelectDelete] = useState(false)
    

    const deleteHandler = ()=>{
        deleteDriver(selectDelete).then(()=>{
            setEditHandler({docid:false})()
            dispatch(setActiveDriver(null))
            dispatch(getDriversFetch())
            setSelectDelete(false)
            toast.success("Driver Deleted Successfully")
        }).catch((e)=>{
            toast.error("Failed to delete driver")
            console.log(e)
        })
    }
    const closeHandler=()=>{
        setSelectDelete(false)
    }
    useEffect(() => {
        dispatch(getDriversFetch())
        return () => {

        }
    }, [dispatch])

    return (
        <section className="text-gray-600 body-font">
            {selectDelete&&<ConfirmDIalouge message={`Delete Driver`} desc="Are you sure want to delete this Driver and it's related info" action='Confirm'  actionHandler={deleteHandler} closeHandler={closeHandler}/>}
            <div className="container px-5 py-10 mx-auto">
                <div className="flex flex-wrap -m-2">
                    {drivers.map((driver,i)=><DriverCard key={i} {...driver} setEditHandler={setEditHandler(driver)} setSelectDelete={setSelectDelete}/>)}
                </div>
            </div>
        </section>
    )
}
